// utils/uploadBus.ts
export type UploadBusEvent =
    | { type: 'upload:planned'; total: number }
    | { type: 'upload:planned-adjust'; delta: number }
    | { type: 'upload:preparing'; delta: number }
    | { type: 'upload:patched'; id: string; patch: any }
    | { type: 'upload:done'; id: string; remoteUrl: string }
    | { type: 'upload:failed'; id: string; error: string }

type Fn = (e: UploadBusEvent) => void
const listeners = new Set<Fn>()

export function onUploadEvent(fn: Fn) {
    listeners.add(fn)
    return () => listeners.delete(fn)
}

export function emitUploadEvent(e: UploadBusEvent) {
    for (const fn of [...listeners]) {
        try {
            fn(e)
        } catch {
            // one throwing listener must not abort delivery to the rest
        }
    }
}
